import { useQuery } from "@tanstack/react-query";
import { isUiMockMode } from "@/config/features";
import { buildExportListApiParams } from "@/domain/export/buildExportListApiParams";
import { computeExportStats } from "@/domain/export/computeExportStats";
import type { ExportListFilters } from "@/domain/export/filterExportJobs";
import { mockExportJobsList } from "@/fixtures/exportJobs";
import { fetchExportJobSummary } from "@/features/exports/api/summary";
import { exportKeys } from "@/lib/query/keys";

export function useExportJobStats(filters: ExportListFilters) {
  const statsFilters = { ...filters, status: "all" as const };

  return useQuery({
    queryKey: [...exportKeys.all, "stats", statsFilters],
    queryFn: async () => {
      if (isUiMockMode()) {
        const all = mockExportJobsList(0, 500);
        return computeExportStats(all.items);
      }
      const params = buildExportListApiParams(0, 1, statsFilters);
      const { page: _page, page_size: _pageSize, status: _status, ...summaryParams } =
        params;
      return fetchExportJobSummary(summaryParams);
    },
    staleTime: 30_000,
  });
}
